import { SelectTypes } from '@genial/components';

export enum PrivatePensionActionsEnum {
  privatePensionApplication = 'privatePensionApplication',
  secondCopy = 'secondCopy',
  changeBeneficiaries = 'changeBeneficiaries',
  downloadProposal = 'downloadProposal',
}

export type PrivatePensionOptions = keyof typeof PrivatePensionActionsEnum;

export const getPrivatePensionActionsList = (insurer: string) => {
  const isDisabledZurich = insurer.includes('ZURICH');

  return [
    { label: 'APLICAÇÕES', value: PrivatePensionActionsEnum.privatePensionApplication },
    {
      label: 'ALTERAR BENEFICIÁRIOS',
      value: PrivatePensionActionsEnum.changeBeneficiaries,
      disabled: isDisabledZurich,
    },
    { label: 'SEGUNDA VIA', value: PrivatePensionActionsEnum.secondCopy, disabled: true },
    {
      label: 'DOWNLOAD DA PROPOSTA',
      value: PrivatePensionActionsEnum.downloadProposal,
      disabled: true,
    },
  ] as SelectTypes.Props['options'];
};
